export const TYPE_OF_CONTENT = {
    titolo: 'TYPE_OF_CONTENT.TITLE',
    titoloMulti: 'TYPE_OF_CONTENT.MULTI_TITLE',
    value: [
        {
            id: 0,
            value: 'TYPE_OF_CONTENT.VALUE.PAGE',
            content_type: 'pagina'
        },
        {
            id: 1,
            value: 'TYPE_OF_CONTENT.VALUE.ANNOUNCEMENT',
            content_type: 'bando'
        },
        {
            id: 2,
            value: 'TYPE_OF_CONTENT.VALUE.PROCEDURE',
            content_type: 'procedura_servizio'
        },
        {
            id: 3,
            value: 'TYPE_OF_CONTENT.VALUE.FAQ',
            content_type: 'faq'
        },
        {
            id: 4,
            value: 'TYPE_OF_CONTENT.VALUE.TEACHER',
            content_type: 'docente'
        },
        {
            id: 5,
            value: 'TYPE_OF_CONTENT.VALUE.EVENT',
            content_type: 'evento'
        },
        {
            id: 6,
            value: 'TYPE_OF_CONTENT.VALUE.NEWS',
            content_type: 'notizia'
        },
        {
            id: 7,
            value: 'TYPE_OF_CONTENT.VALUE.CONVENTION',
            content_type: 'convenzione'
        },
        {
            id: 8,
            value: 'TYPE_OF_CONTENT.VALUE.RESIDENCE',
            content_type: 'alloggio_residenza'
        },
        {
            id: 9,
            value: 'TYPE_OF_CONTENT.VALUE.NOTICE',
            content_type: 'avviso'
        },
        {
            id: 10,
            value: 'TYPE_OF_CONTENT.VALUE.PERSON',
            content_type: 'persona'
        },
        {
            id: 11,
            value: 'TYPE_OF_CONTENT.VALUE.COURSE',
            content_type: 'corso_di_studi'
        },
        {
            id: 11,
            value: 'TYPE_OF_CONTENT.VALUE.ARCHIVE_EVENT',
            content_type: 'archivio_evento'
        },
        {
            id: 11,
            value: 'TYPE_OF_CONTENT.VALUE.ARCHIVE_NEWS',
            content_type: 'archivio_notizia'
        }
    ]
}